export const HISTORY_PER_PAGE = 10;
